var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{staticClass:"py-5",attrs:{"cols":"12","align":"center"}},[_c('div',{staticClass:"mt-1"},[_c('v-img',{attrs:{"width":"50","src":require("@/assets/anything/file.svg")}})],1),_c('b',[_vm._v(_vm._s(_vm.$t('no-item')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }